export const maskCNPJCPF = (value: string | number): string => {
  if (!value) return ''

  value = value.toString().replace(/[^a-zA-Z0-9]/g, '').toUpperCase()

  value = value.slice(0, 14)

  if (value.length <= 11) {
    value = value.replace(/(\d{3})(\d)/, '$1.$2')
    value = value.replace(/(\d{3})(\d)/, '$1.$2')
    value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
  } else {
    value = value.replace(/^([A-Z0-9]{2})([A-Z0-9])/, '$1.$2')
    value = value.replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3')
    value = value.replace(/\.([A-Z0-9]{3})([A-Z0-9])/, '.$1/$2')
    value = value.replace(/([A-Z0-9]{4})([0-9])/, '$1-$2')
  }
  
  return value
}

export const isCpf = (value: string | undefined) => {
  if (!value) return false
  const cleanedValue = value.replace(/\D/g, '')
  if (cleanedValue.length !== 11) return false

  for (let i = 0; i < 10; i++) {
    if (cleanedValue === Array(12).join(String(i))) return false
  }

  let sum = 0
  for (let i = 0; i < 9; i++) {
    sum += Number(cleanedValue.charAt(i)) * (10 - i)
  }
  let check = 11 - (sum % 11)
  if (check === 10 || check === 11) {
    check = 0
  }
  if (check !== Number(cleanedValue.charAt(9))) {
    return false
  }

  sum = 0
  for (let i = 0; i < 10; i++) {
    sum += Number(cleanedValue.charAt(i)) * (11 - i)
  }
  check = 11 - (sum % 11)
  if (check === 10 || check === 11) {
    check = 0
  }
  if (check !== Number(cleanedValue.charAt(10))) {
    return false
  }

  return true
}

export const isCnpj = (value: string | undefined) => {
  if (!value) return false
  const cleanedValue = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()

  // Verifica se todos os números são iguais, como 000000000000 ou 111111111111
  if (/^(.)\1+$/.test(cleanedValue)) return false

  if (cleanedValue.length !== 14) return false

  const firstWeights = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  const secondWeights = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

  const calculateDigit = (digits: string, weights: number[]) => {
    let sum = 0
    for (let i = 0; i < weights.length; i++) {
      sum += Number(digits[i].charCodeAt(0) - 48) * weights[i]
    }
    const mod = sum % 11
    return mod < 2 ? 0 : 11 - mod
  }
  
  if (isNaN(Number(cleanedValue.slice(12, 14)))) return false
  const firstDigit = calculateDigit(cleanedValue, firstWeights)
  const secondDigit = calculateDigit(cleanedValue + firstDigit, secondWeights)

  return cleanedValue.endsWith(firstDigit.toString() + secondDigit.toString())
}

export const isRgValid = (value: string) => {
  const cleanedValue = value.replace(/\D/g, '')
  return cleanedValue.length >= 4
}

export const onlyNumbers = (value: string) => {
  return value.replace(/\D/g, '')
}

export const cleanDocument = (value: string): string => {
  return value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()
}